import React, { Component } from 'react'
import { connect } from 'react-redux'
import Plx from 'react-plx';

//import T from '../../../translate/T'
import Footer from './../../../../src/SPRINTA/Footer';
import { Container, ContainerFluid, Row, Col } from './../../../../src/SPRINTA/atoms/Grid';
import CoverImage from './../../../../src/SPRINTA/atoms/CoverImage';
import ContactForm from '../../Components/ContactForm'
import './../effects.css';

import style from './style.css'

const headerparallax = [
  {
    start: 0,
    duration: 800,
    properties: [
      {
        startValue: 0,
        endValue: 50,
        property: "translateY"
      }
    ]
  }
]

class Grupos extends Component {
  constructor() {
    super();
    this.state = {
       mac: 'instmonteright hidden',
       calendario: 'instgerencieleftimg hidden',
       cel:'hidden',
       tweets:'gruexclusivosimg hidden',
       balao1:'balao1 hidden',
       balao2:'balao2 hidden',
    }
  }
  handleScroll() {
    //console.log(document.documentElement.scrollTop);
    var item = 'instmonteright animated fadeInRight';
    var calendario = 'instgerencieleftimg animated fadeInLeft';
    var cel = 'gruexclusivosleft animated zoomIn';
    var tweets = 'gruexclusivosimg zoomIn animated';
    var balao1 = 'gbalao1 zoomIn animated';
    if (document.documentElement.scrollTop > 300 && this.state.item !== item){
      this.setState({
        mac: item
      })
    }
    if (document.documentElement.scrollTop > 600 && this.state.calendario !== calendario){
      this.setState({
        calendario: calendario
      })
    }
    if (document.documentElement.scrollTop > 1200 && this.state.cel !== cel){
      this.setState({
        cel: cel
      })
    }
    if (document.documentElement.scrollTop > 2200 && this.state.tweets !== tweets){
      this.setState({
        tweets: tweets
      })
    }
    if (document.documentElement.scrollTop > 1650 && this.state.balao1 !== balao1){
      this.setState({
        balao1: balao1
      })
      setTimeout(function(){
        this.setState({
          balao2: 'gbalao2 animated zoomIn'
        })
      }.bind(this), 1000);
    }
  }
  componentDidMount() {
   window.onscroll = () => this.handleScroll()
  }
  render() {
    return (
      <div>
        <ContainerFluid>
          <Row>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
              <Plx
              className={style.instheader}
                parallaxData={ headerparallax }
              >
                <CoverImage className={style.instheader} image={require('./background.jpg')}>
                  <Container>
                    <h1>Treine com amigos,<br />clientes ou conhecidos</h1>
                    <p>Crie um grupo para seus amigos, marca ou assessoria esportiva<br />e conecte pessoas com os mesmos interesses</p>
                  </Container>
                </CoverImage>
              </Plx>
            </Col>
            <Col size="12" className={style.instmonte}>
              <Container>
                <Row>

                  <Col size="12 6" float="center right" className={this.state.mac}>
                    <img alt="" src={require('./mac.png')}/>
                  </Col>

                  <Col size="12 6" text="center left" float="center left" className={style.instmonteleft}>
                    <h1><b>Clubes</b>, <b>grupos</b>,<br /><b>treinos</b> e <b>pessoas</b><br />com os mesmos<br />interesses que você</h1>
                    <p>Treine, desafie-se, crie um grupo com atletas com os mesmos interesses que você, viva experiências únicas no esporte que você ama e monte o seu próprio evento.</p>
                  </Col>

                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instgerencie}>

              <Container>
                <Row>
                  <Col size="12 6" className={style.instgerencieleft} style={{height: '250px'}}></Col>
                  <Col size="12 6" className={style.instgerencieright} text='center left'>
                    <h1>Sua agenda <b>organizada</b><br />e em <b>apenas um lugar</b></h1>
                    <p>Seus eventos e treinos organizados de uma forma muito simples. Basta publicar uma atividade e todos os participantes do grupos receberão uma notificação.</p>
                  </Col>
                </Row>
              </Container>
              <div className={this.state.calendario}>
                <img alt="" src={require('./calendario.jpg')}/>
              </div>
            </Col>
            <Col size="12" className={style.gruexclusivos}>
              <Container>
                <Row>
                   <Col size="12 6" float="center right" style={{textAlign:'center'}} className={this.state.cel}>
                    <img alt="" src={require('./cel.png')}/>
                  </Col>
                  <Col size="12 6" text="center left" float="center left" className={style.gruexclusivosright}>
                    <h1>Grupos <b>exclusivos</b>,<br />com <b>assinatura</b><br />ou <b>mensalidade</b></h1>
                    <p>Seu clube, grupo ou assessoria cobra uma mensalidade dos integrantes? Esqueça a parte burocrática e deixe a plataforma gerenciar essas cobranças para você. Fácil, rápido e simples.</p>
                  </Col>

                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.gruconverse}>
              <Container>
                <Row>
                    <Col size="12 3" text="center left">
                      <h2>Destinatários</h2>
                      <img alt="" src={require('./addparticipantes.png')}/>
                      <img alt="" src={require('./balao1.png')} className={this.state.balao1}/>
                      <img alt="" src={require('./balao2.png')} className={this.state.balao2}/>
                    </Col>
                    <Col size="3"></Col>
                    <Col size="12 6" className={style.gruexclusivosright} text="center left">
                      <h1><b>Converse</b> com<br />membros do seu grupo<br />e siga seus <b>favoritos</b></h1>
                      <p>Você escolhe se seu clube é público, privado, grátis ou pago. Ajuste suas configurações e comece a encontrar pessoas com os mesmos interesses que você. Você nunca mais irá se exercitar sozinho!</p>
                    </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.grupublique}>
              <Container>
                <Row>
                    <Col size="12 6" text="center left" className={style.gruexclusivosright}>
                      <h1>Publique <b>conteúdos</b><br /><b>relevantes</b> para sua<br />comunidade</h1>
                      <p>Posts, fotos, artigos, arquivos e arquivos: Aproveite uma timeline exclusiva para se comunicar com todos os membros do seu grupo.</p>
                    </Col>
                    <Col size="12 6">
                      <div className={this.state.tweets}>
                        <img alt="" src={require('./tweets.png')}/>
                      </div>
                    </Col>
                </Row>
              </Container>
            </Col>
            {/*<Col size="12" className={style.instdesafioscrie}>
              <Container>
                <h1>Converse conosco sobre as <b>vantagens</b><br />de ter um <b>grupo</b> para sua <b>empresa</b></h1>
                <div style={{width:'50%', margin:'0 auto'}}>
                  <Row>
                    <Col size="6">
                      <Text placeholder="Nome" style={{margin:'0 0 20px 0'}}/>
                      <Text placeholder="E-mail"/>
                    </Col>
                    <Col size="6">
                      <Text placeholder="Telefone"style={{margin:'0 0 20px 0'}} />
                      <Text placeholder="Empresa"/>
                    </Col>
                    <Col size="12" style={{margin:'20px 0 40px 0'}}>
                      <Checkbox>Receber newsletter do SPRINTA</Checkbox>
                    </Col>
                  </Row>
                </div>
                <Button inline color="orange">Solicitar contato</Button>
              </Container>
            </Col>*/}
            <Col size="12" className={style.instdesafioscrie}>
              <Container>
                <ContactForm />
              </Container>
            </Col>
          </Row>
        </ContainerFluid>
        <Footer lang="pt-BR" />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Grupos)



// WEBPACK FOOTER //
// ./src/App/pages/Grupos/index.js